import $ from 'jquery';
import 'slick-carousel';

var $slider = $('.js-slider');

$slider.on('init', function () {
    $('.slider__load-image').hide();
});

$slider.slick({
    autoplay: true,
    autoplaySpeed: 7000,
    infinite: true,
    arrows: true,
    dots: true,
    draggable: false,
    prevArrow: '<i class="slick-prev fa-thin fa-chevron-left"></i>',
    nextArrow: '<i class="slick-next fa-thin fa-chevron-right"></i>',
    appendArrows: $('<div>').addClass('absolute-container arrow-container').insertAfter('.js-slider'),
    responsive: [{
        breakpoint: 992,
        settings: {
            draggable: true
        }
    }]
});
